import { useState, useEffect } from 'react';
import modelsService from '../services/modelsService';

/**
 * Hook pour gérer les modèles de prompt avec écoute temps réel
 * @param {string} filter - 'all' pour tous les modèles, 'mine' pour les modèles de l'utilisateur
 * @param {string} userId - ID de l'utilisateur connecté (requis si filter='mine')
 * @returns {Object} { models, loading, error }
 */
const useModels = (filter = 'all', userId = null) => {
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (filter === 'mine' && !userId) {
      setError('userId requis pour filter="mine"');
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    let unsubscribe;

    try {
      if (filter === 'mine') {
        unsubscribe = modelsService.getUserModels(userId, (updatedModels) => {
          setModels(updatedModels);
          setLoading(false);
        });
      } else {
        unsubscribe = modelsService.getAllModels((updatedModels) => {
          setModels(updatedModels);
          setLoading(false);
        });
      }
    } catch (err) {

      setError(err.message);
      setLoading(false);
    }

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [filter, userId]);

  return { models, loading, error };
};

export default useModels; 